export default __webpack_public_path__ + "static/media/ctop.f7a2a1d8.png";